
































































import { Vue, Component, Prop } from 'vue-property-decorator';
import ModulesHelper from '@core/services/modules.helper';

@Component({
  name: 'bpc-booking-event-refuse-modal',
  components: {},
})
export default class BookingEventRefuseModal extends Vue {
  @Prop({ type: Boolean, default: false }) readonly showModal: boolean;
  @Prop({ type: Boolean, default: false }) readonly ownToRepetitiveBooking: boolean;
  @Prop({ type: Array, default: [] }) readonly eventIds: string[] | number[];

  refusingEvents: boolean = false;
  repetitiveActionOptionSelected: string = 'only_this';
  repetitiveActionOptions: Record<string, any> = [
    {
      text: this.$t('global.modals.update-booking-event.multiple.action_option.options.only'),
      value: 'only_this',
    },
    {
      text: this.$t(
        'global.modals.update-booking-event.multiple.action_option.options.next_same_events',
      ),
      value: 'next_same',
    },
    {
      text: this.$t(
        'global.modals.update-booking-event.multiple.action_option.options.all_same_events',
      ),
      value: 'all_same',
    },
    {
      text: this.$t(
        'global.modals.update-booking-event.multiple.action_option.options.refuse_all_events',
      ),
      value: 'refuse_all',
    },
  ];

  orderActionOptionSelected: boolean = true;
  orderActionOptions: Record<string, any> = [
    {
      text: this.$t('global.modals.update-booking-event.multiple.orders.options.no_update'),
      value: false,
    },
    {
      text: this.$t('global.modals.update-booking-event.multiple.orders.options.update'),
      value: true,
    },
  ];

  notificationActionOptionSelected: boolean = true;
  notificationActionOptions: Record<string, any> = [
    {
      text: this.$t('global.no'),
      value: false,
    },
    {
      text: this.$t('global.yes'),
      value: true,
    },
  ];

  get totalItemsToRefuse(): number {
    return this.eventIds.length;
  }

  get modalTitle(): string {
    if (this.totalItemsToRefuse > 1) {
      return this.$t('global.modals.multiple_booking_event_refuse.title').toString();
    } else {
      return this.$t('global.modals.single_booking_event_refuse.title').toString();
    }
  }

  get modalBody(): string {
    if (this.eventIds.length > 1) {
      return this.$t('global.modals.multiple_booking_event_refuse.body').toString();
    } else {
      return this.$t('global.modals.single_booking_event_refuse.body').toString();
    }
  }

  get modalBodyOrders(): string {
    return this.$t('bookings.bookings.cancel_orders.label').toString();
  }

  get modalBodyNotification(): string {
    return this.$t('bookings.booking_events.notify_by_email.label').toString();
  }

  get modalBodyRepetitive(): string {
    return this.$t('global.modals.update-booking-event.multiple.action_option.label').toString();
  }

  get showNotifyOption(): boolean {
    return (
      this.$modulesService.hasModuleActivated(ModulesHelper.COMMUNICATIONS_MODULE_NAME) &&
      this.$store.getters['centerSettings/centerSettings']?.send_booking_refused_email
    );
  }

  get showOrderOption(): boolean {
    return this.$modulesService.hasModuleActivated(ModulesHelper.ACCOUNTING_MODULE_NAME);
  }

  onCloseModal(): void {
    this.$emit('close');
    this.refusingEvents = false;
    this.repetitiveActionOptionSelected = 'only_this';
    this.orderActionOptionSelected = true;
    this.notificationActionOptionSelected = true;
  }

  onConfirmSingleRefuse(): void {
    this.refusingEvents = true;
    const basePath = this.$bpcApiRouteHelper.getEntityPath('booking-event');
    const eventId = this.eventIds[0];
    const path = `${basePath}/refuse/${eventId}`;
    this.$bpcApi
      .put(path, {
        id: eventId,
        repetitiveAction: this.repetitiveActionOptionSelected,
        updateOrders: this.orderActionOptionSelected,
        notifyByEmail: this.notificationActionOptionSelected,
      })
      .subscribe(
        () => {
          this.$emit('refused');
          this.$bpcMessage.showSuccessMessage({
            text: 'global.booking_event.success_single_refuse',
          });
          this.onCloseModal();
        },
        () => {
          this.onCloseModal();
        },
      );
  }

  onConfirmMultipleRefuse(): void {
    console.log('Multiple refuse');
  }
}
